'use strict';

/**
 * @ngdoc service
 * @name 360StoreAngularApp.session
 * @description
 * # session
 * Service in the 360StoreAngularApp.
 */
angular.module('360StoreAngularApp')
	.service('session', function ($rootScope, Analytics, api) {
		const service = this;

		/**
		 * @type {CartAction[]}
		 */
		service.cartActions = null;
		service.account = null;

		service.reset = function () {
			service.cartActions = JSON.parse(localStorage.getItem('cartActions')) || [];
		};

		function _persistCart() {
			localStorage.setItem('cartActions', JSON.stringify(service.cartActions));
		}

		service.addCartAction = function (/**CartAction*/ action) {
			// should we just clear the cart when adding a thing? Who orders multiple different products in one go?
			// Yeah, we should.
			this.cartActions = Array.isArray(action) ? action : [action];
			_persistCart();
			return action;
		};

		/**
		 * Swaps in actions the server has re-priced -- same items, new numbers -- so the cart the customer sees and
		 * the cart we post at checkout can never disagree.
		 * @param actions {CartAction[]}
		 */
		service.replaceCartActions = function (actions) {
			service.cartActions = actions;
			_persistCart();
			return actions;
		};

		service.removeCartAction = function (cartAction) {
			const index = service.cartActions.indexOf(cartAction);
			if (index === -1) {
				return;
			}
			/**
			 * @type {CartAction}
			 */
			const removed = service.cartActions.splice(index, 1)[0];
			try {
				Analytics.remove_from_cart(removed);
			} catch (e) {
				console.warn('Unable to log removal', e);
			}
			_persistCart();
		};


		service.login = function (credentials) {
			return api.login(credentials)
				.then(function (account) {
					service.account = account;
					$rootScope.$broadcast('authChanged'); // Broadcast event
					return account;
				});
		};

		/**
		 * @param params {{userId:string}}
		 * @return {Promise<Account>}
		 */
		service.switchUser = function (params) {
			return api.adminSwitchUser(params)
				.then(function (account) {
					service.account = account;
					window.toastr.info('You are logged in as ' + account?.email, 'User Switched')
					$rootScope.$broadcast('authChanged'); // Broadcast event
					return account;
				});
		};

		service.getOrFetchCurrentUser = async () => {
			if (!service.account) {
				console.log('session.account is empty. Fetching currentUser from api');
				service.account = await api.currentUser();
				console.log('currentUser', service.account);
				$rootScope.$broadcast('authChanged'); // Broadcast event
			}
			return service.account;
		};

		service.logout = async function () {
			try {
				service.currentUser = await api.logout();
			} catch (e) {
				service.currentUser = null;
			} finally {
				$rootScope.$broadcast('authChanged');
			}
			return service.currentUser;
		};

		service.clearCart = function () {
			service.cartActions = [];
			_persistCart();
		};

		service.isAuthenticated = function () {
			return !!service.currentUser;
		};

		service.reset();
	});
